import type { Block } from '../../../../types/proposal-blocks';
import { renderMarkdown } from './markdown';

type Data = Extract<Block, { type: 'clauses' }>;

export function ClausesBlock({ block }: { block: Data }) {
  return (
    <div className="my-6">
      <h2 className="text-[22px] font-bold tracking-tight text-proposal-fg1 leading-tight mb-6">{block.title}</h2>
      {block.items.map((clause, i) => (
        <div key={i} className="mb-6 pl-4 border-l-2 border-proposal-border">
          <div className="flex items-baseline gap-3 mb-2">
            <span className="font-proposal-mono text-[11px] font-semibold text-proposal-fg3">{clause.number}</span>
            <h3 className="text-sm font-semibold text-proposal-fg1">{clause.title}</h3>
          </div>
          <div className="pl-8">{renderMarkdown(clause.body_md)}</div>
        </div>
      ))}
    </div>
  );
}
